<template>
    <b-container style="margin-top: 20px">
        <b-row :v-if="updateSubmitted">
            <b-col>
                <div v-if="updateSubmitted">
                    <b-form-text></b-form-text>
                    {{ updateStatus }}
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="3">
                Winery:
            </b-col>
            <b-col cols="5">
                <b-form-select v-model="winery" :options="wineryOptions"
                               v-on:change="fetchWineryInfo"
                               @selected="fetchWineryInfo"></b-form-select>
            </b-col>
        </b-row>
        <b-row :v-if="wineryDetails !== null">
            <b-col>
                <div v-if="showDetails">
                    <b-form-text></b-form-text>
                    <span style="font-weight: bold; font-size: 20px">Winery Name: </span> {{wineryDetails.name}}
                </div>
            </b-col>
        </b-row>

        <b-row style="margin-bottom: 10px">
            <b-col cols="12">
                <b-form-group label="Compliance Flag?">
                    <b-form-radio-group
                            v-model="complianceFlag"
                            :options="yesNoOptions"
                            name="flavour-2a"
                            stacked
                    >
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                If yes, date of non-compliance:
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                <datepicker v-model="nonComplianceDate"></datepicker>
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                If yes, what is the specific compliance concern:
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                <b-form-textarea v-model="specificConcern"></b-form-textarea>
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                <b-form-group label="Has company been notified? ">
                    <b-form-radio-group
                            v-model="companyNotified"
                            :options="yesNoOptions"
                            name="companyNotified"
                            stacked
                    >
                    </b-form-radio-group>
                </b-form-group>
            </b-col>

        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                Who should the company contact to resolve the compliance issue?:
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-textarea v-model="contactPerson"></b-form-textarea>
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px">
            <b-col>
                Online resources providing compliance information:
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-textarea v-model="resourceLink"></b-form-textarea>
            </b-col>
        </b-row>
        <div class="button-holder" style="margin-top: 20px">
            <b-row align-h="center">
                <b-col cols="2">
                    <b-button style="color: white; background-color: green" class="submit-button"
                              type="submit" @click="submitCompliance"
                              variant="primary">Submit
                    </b-button>
                </b-col>
                <b-col cols="2">
                    <b-button style="color: white; background-color: green" class="cancel-button"
                              type="cancel" @click="cancel"
                              variant="primary">Cancel
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

Compliance Flag? Yes   |   No
If yes, date of non-compliance:
If yes, what is the specific compliance concern:
Has company been notified? Yes   |   No
Who should the company contact to resolve the compliance issue?:
Online resources providing compliance information:


<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker
  },
  name: "ComplianceQuestions",
  data() {
    return {
      winery: null,
      wineryOptions: [],
      wineryDetails: {},
      showDetails: false,
                complianceId: '',
                complianceFlag: '',
                nonComplianceDate: '',
                specificConcern: '',
                companyNotified: '',
                contactPerson: '',
                resourceLink: '',
                yesNoOptions: ['Yes', 'No'],
                updateStatus: '',
                updateSubmitted: false,


            }
        },
        mounted() {
            this.$http.get("compliance")
                .then(result => {
                    let self = this;
                    let wineryMap = new Map(Object.entries(result.data));
                    console.log(wineryMap);

                    wineryMap.forEach((key, value) => {
                        self.wineryOptions.push({text: key, value: value})
                    });

                    console.log(self.wineryOptions);
                }).catch(err => {
                console.log("Error Retrieving WineryOptions", err);
            })
        },
        methods: {
            cancel: function () {
                this.$router.push("/my-account")
            },
            fetchWineryInfo: function (evt) {
                let self = this;
                console.log("Before call to get group details." + this.winery);
                this.$http.get("compliance/group/details/" + this.winery)
                    .then(result => {
                        let self = this;
                        console.log(result.data);
                        self.wineryDetails = result.data;
                        console.log(self.wineryDetails);
                        this.showDetails = true;
                        return this.winery;
                    })
                    .then(details => {
                        this.$http.get("compliance/group/" + details)
                            .then(compl => {
                                let complianceVals = compl.data;
                                if (complianceVals !== undefined && !(typeof complianceVals === "object" && !complianceVals)) {
                                    self.complianceFlag = complianceVals.complianceFlag;
                                    self.nonComplianceDate = complianceVals.nonComplianceDate;
                                    self.specificConcern = complianceVals.specificConcern;
                                    self.companyNotified = complianceVals.companyNotified;
                                    self.contactPerson = complianceVals.contactPerson;
                                    self.resourceLink = complianceVals.resourceLink;
                                    self.complianceId = complianceVals._id;
                                } else {
                                    self.complianceFlag = '';
                                    self.nonComplianceDate = '';
                                    self.specificConcern = '';
                                    self.companyNotified = '';
                                    self.contactPerson = '';
                                    self.resourceLink = '';
                                    self.complianceId = '';
                                }
                            })
                    })
                    .catch(err => {
                        console.log("Error Retrieving WineryDetails", err);
                        this.showDetails = false;
                    })
            },
            submitCompliance: function () {
                let self = this;
                console.log("About to post Compliance Information" + this.winery);
                let complianceUpdate = {};

                let complianceObject = {
                    complianceFlag: this.complianceFlag,
                    nonComplianceDate: this.nonComplianceDate,
                    specificConcern: this.specificConcern,
                    companyNotified: this.companyNotified,
                    contactPerson: this.contactPerson,
                    resourceLink: this.resourceLink,
                    groupId: this.winery,
                    _id: this.complianceId
                };
                console.log(complianceObject);
                this.$http.post("compliance/" + this.winery, JSON.stringify(complianceObject),
                    {
                        headers: {
                            'content-type': 'application/json'
                        }
                    }).then(result => {
                    if (result.status === 200 || result.status === 204) {
                        self.updateStatus = "Update Successful!";
                        swal("Survey saved.");
                    } else {
                        self.updateStatus = "Update Failed.";
                        swal("Survey Update failed, Please Contact Administrator.");
                    }
                    self.updateSubmitted = true;
                })
                    .catch(error => {
                        console.log(error);
                        self.updateStatus = "Update Failed.";
                        self.updateSubmitted = true;
                    })

            }
        }
    }
</script>

<style scoped>

</style>
